import { Component, EventEmitter, NgZone, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ApiserviceService } from '../Service/apiservice.service';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { CryptoService } from '../services/crypto-services/crypto-services';
// import * as jq from 'jquery';
@Component({
  selector: 'app-tracksr',
  templateUrl: './tracksr.component.html',
  styleUrls: ['./tracksr.component.scss']
})
export class TracksrComponent {
  track_with_refno: any = ''
  userInfoList: any = localStorage.getItem('userListSubmit');
  submitSrDetails: any;
  @Output() componentSelection = new EventEmitter<any>();
  // dataSource = new MatTableDataSource<any>([
  //   { id: 1, srID: '24207-000450', department: 'Animal care and Control', srReportDate: new Date(), srStatus: 'Pending', serviceAddress: '123 Main St' },
  //   { id: 2, srID: '24207-000451', department: 'Forestry', srReportDate: new Date(), srStatus: 'In Progress', serviceAddress: '456 Elm St' },
  //   { id: 3, srID: '24207-000452', department: 'Animal care and Control', srReportDate: new Date(), srStatus: 'Completed', serviceAddress: '200 e berry st' },
  //   { id: 4, srID: '24207-000453', department: 'Filtration', srReportDate: new Date(), srStatus: 'Pending', serviceAddress: '456 Elm St' },
  //   { id: 5, srID: '24207-000454', department: 'Forestry', srReportDate: new Date(), srStatus: 'In Progress', serviceAddress: '456 Elm St' },
  //   { id: 6, srID: '24207-000455', department: 'Parking Control', srReportDate: new Date(), srStatus: 'Pending', serviceAddress: '200 e berry st' },
  //   // Add more static data entries here
  // ]);
  displayedColumns: string[] = ['id', 'srID', 'department', 'srReportDate', 'srStatus', 'serviceAddress','open'];


  constructor(public dialog: MatDialog, private makeservicerequest: ApiserviceService,private _ngZone: NgZone,  private cryptoService: CryptoService,private http: HttpClient,private datePipe: DatePipe) {

  }
  formatDate(date: Date): any {
    return this.datePipe.transform(date, 'MMM dd, yyyy');
  }
  tcontainer = {
    'height': ($(window).height() - $('.layout-navbar').height() - 120) + 'px',
    'overflow': 'hidden',
    'overflow-y': 'auto'
  };
  tcontainerbody = {
    height:(($(window).height() - $('.layout-navbar').height()) - 350) + 'px'
  };
  ngOnInit() {


    // this.getRecentIncidents();
    this.datatablepagination()

    if(this.makeservicerequest.referrence_number!=0)
    {
      this.track_with_refno=this.makeservicerequest.referrence_number
      this.getByreferrenceId()
    }
    // if (data.rowData[j][k].action.actionType == 'Open') {
    //   tableTr += '<td class=""><button data-tabname="' + this.tabName + '" data-obj=' + this.cryptoService.set(data.rowData[j][k]) + ' data-row=' + this.cryptoService.set(data.rowData[j]) + ' class="btn btn-outline-primary btn-xs openReport">Open</button></td>';
    // }

  }
  componentSelectionEmitter(componentData: object) {
    console.log(componentData);

    setTimeout(() => {
      this._ngZone.run(() => {
        this.componentSelection.emit(componentData);
      })


      // this._appRef.tick();
      // this._standardUiService.changeDetection();
      // this._detectChanges.detectChanges();
      // this._detectChanges.markForCheck();
      // this._detectChanges.();
    }, 200);

  }
  trackSRdata:any;
  check(item:any) {
    console.log(item)

        let tabName = $(this).data('tabname');
        let d = { id: item.id, name:item.refno, type: 'object', entityName:item.entityName, department: item.department};

        console.log(d);
        this.trackSRdata = d;
        console.log(this.trackSRdata);

        this.componentSelectionEmitter(this.trackSRdata);

    console.log(this.trackSRdata);
}


  // datatablepagination() {
  //   console.log("in datatablepagination")
  //   setTimeout(() => {
  //     ($('#trackservicetable') as any).dataTable({
  //       "language": {
  //         "paginate": {
  //           "previous": "«",
  //           "next": "»"
  //         }
  //       },
  //       order: [],
  //       "retrieve": true,
  //       "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
  //       "bPaginate": true,
  //     });
  //   }, 200);
  // }

  datatablepagination() {
    // alert(this.tableId)
    ($('#trackservicetable') as any).DataTable().destroy();


    setTimeout(() => {
      ($('#trackservicetable') as any).dataTable({
        "language": {
          "paginate": {
            "previous": "",
            "next": ""
          },
          "lengthMenu": "Records per page _MENU_ ",
        },
        //"order": [[2, "asc"]],
        "columnDefs": [
          { "orderable": false, "targets": 0 },
          { "orderable": false, "targets": 1 }
        ],

        // "bDestroy": true,
        // columnDefs: this.customSortCols,
        // dom: 'frtip',

        // "lengthMenu": [[1500], [1500]],
        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
        "bPaginate": true,
        "bDestroy": true,
        drawCallback: function (settings: any) {
          const api = this.api();
          const rows = api.rows({ page: 'current' }).nodes();
          let startIndex = api.page() * api.page.len() + 1;

          $(rows).each(function (index) {
            $('td', this).eq(0).html(startIndex.toString()); // Convert to string before setting as HTML content
            startIndex++;
          });
        },
      });
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0;
    }, 1000);
  }

  checkIfEmpty() {
    console.log("keyup")
    if (this.track_with_refno == '') {
      this.clearsearch()
    }
  }

  clearsearch() {
    this.track_with_refno = ''
    this.recentincidents = this.updatedrecentincidents
    this.datatablepagination()
  }
  openstatus(refno:any)
  {

  }
  getByreferrenceId() {
    // console.log("hi")
    // console.log(this.track_with_refno.length)
    // if (true) {
this.makeservicerequest.getByIncidentByRefno(this.track_with_refno).subscribe((data: any) => {
      console.log(data)
      // console.log(data['refno'])
      console.log(data)
      this.recentincidents = []
      if (Object.keys(data).length === 0 && data.constructor === Object) {
        this.recentincidents = []
      }
      else {
        this.recentincidents = []
        console.log(this.recentincidents)
        this.recentincidents.push(data)
      }

      console.log(this.recentincidents)
      this.datatablepagination()
    })
    // }
    // else {
    //   this.recentincidents = this.updatedrecentincidents
    //   // this.datatablepagination()
    // }

    // alert(this.track_with_refno.value.length)

  }
  recentincidents: any = [];
  updatedrecentincidents: any = []
  ShowDiv()
  {

  }
  // getRecentIncidents() {
  //   this.makeservicerequest.getrecentIncidents().subscribe(
  //     (data) => {
  //       this.recentincidents = data;
  //       console.log(data);
  //       this.updatedrecentincidents = this.recentincidents

  //       if (this.makeservicerequest.referrence_number != 0) {
  //         console.log("undefined")
  //         this.track_with_refno = this.makeservicerequest.referrence_number
  //         console.log(this.track_with_refno)
  //         this.getByreferrenceId()
  //         this.makeservicerequest.referrence_number=0
  //       }
  //     },
  //     (error) => {
  //       console.error('Error fetching recent incidents:', error);
  //     }
  //   );
  // }
  refno: any;
  ngAfterViewInit() {
    // this.makeservicerequest.referencenum;
    // this.refno = this.makeservicerequest.referencenum;

    // if (this.refno !== undefined) {

    //   this.track_with_refno = this.refno;

    //   this.getByreferrenceId();

    // }

    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
  }
  // openPopup() {

  //   this.dialog.open(PopupComponent, {
  //     width: '440px'
  //   });
  // }

  trackOpen: boolean = false;
  serviceRequest: any;
  //   clickTrack(){
  //     if(this.userInfoList){
  //       let userList=JSON.parse(this.userInfoList);
  //       let selectedList = userList.filter((item:any) => item.srID == this.serviceRequest);
  //       this.submitSrDetails = selectedList.length ?selectedList[0]:"";
  //       this.trackOpen = this.submitSrDetails?true:false;

  //       if(this.trackOpen){
  //       jq(".l-seaech").parents().find('#track-div').addClass('tracktable');
  //       }else{
  //       jq(".l-seaech").parents().find('#track-div').removeClass('tracktable');
  //       }
  //     }

  //  }

  searchQuery: string = '';
  dataSourcee: any[] = [
    { id: 1, srID: '24207-000450', department: 'Animal care and Control', srReportDate: new Date(), srStatus: 'Pending', serviceAddress: '123 Main St' },
    { id: 2, srID: '24207-000451', department: 'Forestry', srReportDate: new Date(), srStatus: 'In Progress', serviceAddress: '456 Elm St' },
    { id: 3, srID: '24207-000452', department: 'Animal care and Control', srReportDate: new Date(), srStatus: 'pending', serviceAddress: '200 e berry st' },
    { id: 4, srID: '24207-000453', department: 'Filtration', srReportDate: new Date(), srStatus: 'Pending', serviceAddress: '456 Elm St' },
    { id: 5, srID: '24207-000454', department: 'Forestry', srReportDate: new Date(), srStatus: 'In Progress', serviceAddress: '456 Elm St' },
    // { id: 6, srID: '24207-000455', department: 'Parking Control', srReportDate: new Date(), srStatus: 'Pending', serviceAddress: '200 e berry st' },
    // { id: 7, srID: '24207-000457', department: 'Property Management', srReportDate: new Date(), srStatus: 'In Progress', serviceAddress: '456 Elm St' },
    // { id: 8, srID: '24207-000458', department: 'Filtration', srReportDate: new Date(), srStatus: 'Pending', serviceAddress: '456 Elm St' },

    // { id: 9, srID: '24207-000459', department: 'Parking Control', srReportDate: new Date(), srStatus: 'In Progress', serviceAddress: '200 e berry st' },

    // Add more dummy data entries here
    // Repeat this pattern for 10 entries
  ];

  //  applyFilter(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.dataSource.filter = filterValue.trim().toLowerCase();
  //   if (this.dataSource.paginator) {
  //     this.dataSource.paginator.firstPage();
  //   }
  // }
}
function jq(arg0: string) {
  throw new Error('Function not implemented.');
}

